import { useEffect, useState } from 'react';
import { getCatalogs } from '../../services/clientService';

export function useGetCatalogs() {
  const [nationalityOptions, setNationalityOptions] = useState([]);
  const [entityTypeOptions, setEntityTypeOptions] = useState([]);
  const [genderOptions, setGenderOptions] = useState([]);
  const [maritalStatusOptions, setMaritalStatusOptions] = useState([]);
  const [sacOptions, setSacOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const controller = new AbortController();
    const fetchCatalogs = async () => {
      setLoading(true);
      setError(null);
      try {
        const data = await getCatalogs(controller.signal);

        const nationalities = (data.countries || []).map((item) => ({
          label: item.description,
          value: item.id,
        }));
        setNationalityOptions(nationalities);

        const entityTypes = (data.identityTypes || []).map((item) => ({
          label: item.description,
          value: item.id,
        }));
        setEntityTypeOptions(entityTypes);

        const genders = (data.generes || []).map((item) => ({
          label: item.description,
          value: item.id,
        }));
        setGenderOptions(genders);

        const maritalStatuses = (data.maritalStatuses || []).map((item) => ({
          label: item.description,
          value: item.id,
        }));
        setMaritalStatusOptions(maritalStatuses);

        const sacData = (data.userSAC || []).map((item) => ({
          label: item.name,
          value: item.id,
        }));

        setSacOptions(sacData);
      } catch (err) {
        console.error('Error fetching catalogs:', err);
        setError(err.customMessage || 'Error al cargar los catalogos');
      } finally {
        setLoading(false);
      }
    };

    fetchCatalogs();

    return () => controller.abort();
  }, []);

  return {
    nationalityOptions,
    entityTypeOptions,
    genderOptions,
    maritalStatusOptions,
    sacOptions,
    loading,
    error,
  };
}
